import React, { FC, ReactNode } from 'react'

export const LocationHighlighterIcon: FC<ReactNode> = () => {
  return (
    <div className='icon-container' data-testid='location-highlighter-icon'>
      <img
        srcSet={
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/e0702cac7f7223f326df9c6c8f4891a1_IS24_Location_highlighter.png, ' +
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/67474e19ff6cae24aa0148266b487082_IS24_Location_highlighter@2x.png 2x, ' +
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/4ffbf95ed94f7acf92fa1a1ef44a3c00_IS24_Location_highlighter@3x.png 3x'
        }
        src={
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/e0702cac7f7223f326df9c6c8f4891a1_IS24_Location_highlighter.png'
        }
        width={80}
        height={76}
        alt={''}
      />
    </div>
  )
}
